<template>
  <Category cate-name="asset-es" category-name="資産運用（不動産・その他）" />
</template>

<script>
import Category from '@/components/Category.vue'
export default {
  components: {
    Category
  }
}
</script>

<style scoped></style>
